module.exports = __webpack_public_path__ + "static/img/no-result@2x.d764a1b.png";


//////////////////
// WEBPACK FOOTER
// ./src/base/page-loadfail/no-result@2x.png
// module id = VInT
// module chunks = 22